var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 33 33",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.5a15 15 0 1 0 15 15 15.017 15.017 0 0 0-15-15zm8 16H10.007a1.934 1.934 0 0 0 .291.384l5.909 5.909a1 1 0 1 1-1.414 1.414L8.884 19.3a3.963 3.963 0 0 1 0-5.6l5.909-5.909a1 1 0 1 1 1.414 1.414L10.3 15.116a1.934 1.934 0 0 0-.291.384H24.5a1 1 0 0 1 0 2z",
    fill: "#10b981",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.29c84f11e60600fa7bd972a6efdb5601.svg";
export { ForwardRef as ReactComponent };